const HIDE_CLASS = 'hide-hubspot-chat';
const STYLE_ID = 'hide-hubspot-chat-style';

/** Motivi attivi di hide (scheduler, modal-1, …) — la chat torna solo a count 0. */
const hideReasons = new Set();
let modalHideSeq = 0;

const HIDE_CSS = `
html.hide-hubspot-chat #hubspot-messages-iframe-container,
html.hide-hubspot-chat #hubspot-messages-iframe-container *,
html.hide-hubspot-chat iframe[data-test-id="chat-widget"],
html.hide-hubspot-chat iframe[id*="hubspot" i],
html.hide-hubspot-chat div[class*="hs-shadow-container"] {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
  pointer-events: none !important;
  max-height: 0 !important;
  max-width: 0 !important;
  overflow: hidden !important;
  z-index: -1 !important;
}
`;

const ensureHideStyle = () => {
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = HIDE_CSS;
  document.head.appendChild(style);
};

const applyHideClass = () => {
  ensureHideStyle();
  if (hideReasons.size > 0) {
    document.documentElement.classList.add(HIDE_CLASS);
  } else {
    document.documentElement.classList.remove(HIDE_CLASS);
  }
};

export const hideHubSpotDom = () => {
  const selectors = [
    '#hubspot-messages-iframe-container',
    'iframe[id*="hubspot" i]',
    'div[class*="hs-shadow-container"]',
  ];
  selectors.forEach((selector) => {
    document.querySelectorAll(selector).forEach((node) => {
      if (!(node instanceof HTMLElement)) return;
      node.style.setProperty('display', 'none', 'important');
      node.style.setProperty('visibility', 'hidden', 'important');
      node.style.setProperty('opacity', '0', 'important');
      node.style.setProperty('pointer-events', 'none', 'important');
    });
  });
};

export const removeHubSpotWidget = () => {
  try {
    window.HubSpotConversations?.widget?.close?.();
  } catch (_) {
    /* ignore */
  }
  try {
    window.HubSpotConversations?.widget?.remove?.();
  } catch (_) {
    /* ignore */
  }
  hideHubSpotDom();
};

export const loadHubSpotWidget = () => {
  if (hideReasons.size > 0) return;
  try {
    window.HubSpotConversations?.widget?.load?.();
  } catch (_) {
    /* ignore */
  }
};

/**
 * Nasconde HubSpot per un motivo (es. 'modal', 'scheduler').
 * Ritorna cleanup: al release, se non restano motivi, ripristina la chat.
 */
export const hideHubSpotFor = (reason = 'default') => {
  hideReasons.add(reason);
  applyHideClass();
  removeHubSpotWidget();

  return () => {
    hideReasons.delete(reason);
    applyHideClass();
    if (hideReasons.size === 0) {
      loadHubSpotWidget();
    }
  };
};

/** Convenience: hide mentre un Modal è aperto (id univoco per stack di modal). */
export const hideHubSpotForModal = () => {
  modalHideSeq += 1;
  return hideHubSpotFor(`modal-${modalHideSeq}`);
};

/**
 * Nasconde HubSpot in modo persistente su una route (API + CSS + observer).
 * Ritorna cleanup da chiamare uscendo dalla route.
 */
export const suppressHubSpotChat = () => {
  const release = hideHubSpotFor('scheduler');

  const onReady = () => {
    if (hideReasons.has('scheduler')) {
      removeHubSpotWidget();
    }
  };
  window.hsConversationsOnReady = [...(window.hsConversationsOnReady || []), onReady];

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (!hideReasons.has('scheduler') || scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      hideHubSpotDom();
    });
  });
  observer.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true,
  });

  const intervalId = window.setInterval(() => {
    if (!hideReasons.has('scheduler')) return;
    removeHubSpotWidget();
  }, 2000);

  return () => {
    observer.disconnect();
    window.clearInterval(intervalId);
    if (Array.isArray(window.hsConversationsOnReady)) {
      window.hsConversationsOnReady = window.hsConversationsOnReady.filter((fn) => fn !== onReady);
    }
    release();
  };
};
